import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import { useSelector, useDispatch } from 'react-redux';

import ProjNavСhain from './ProjNavСhain'

//****** START MENU OBJECT ****************
const menuData = [
  { name: 'Projects', path: '/projects', children: [] },
  //{ name: 'Test', path: '/test', children: [] },
  { name: 'Log Out', path: '/login', children: [] },
];

const menuData1 = [
  { name: 'Home', path: '/', children: [] },
  { name: 'Stats', path: '/stats', children: [] },
  {
    name: 'Sensors t,h',
    path: '/selected_devicex',
    children: [
      { name: 'Quartz Factory', path: '/sensors_collection/1', children: [] },
      { name: 'Thermo Cameras', path: '/sensors_collection/2', children: [] },
    ],
  },
  {
    name: 'Projects',
    path: '/projects',
    children: [
      { name: 'Staff', path: '/selected_project/1', children: [
        { name: 'selected_desk/1', path: '/selected_desk/1', children: [] },
      ] },
      { name: 'ArtXtal', path: '/selected_project/2', children: [
        { name: 'selected_desk/2', path: '/selected_desk/2', children: [] },
        { name: 'selected_desk/3', path: '/selected_desk/3', children: [] },
      ] },
    ],
  },
  { name: 'Automation', path: '/device_list_automat', children: [] },
  { name: 'Log Out', path: '/login', children: [] },
];

const menuData3 = [
  { name: 'Home', path: '/', children: [] },
  { name: 'Stats', path: '/stats', children: [] },
  {
    name: 'Sensors t,h',
    path: '/selected_devicex',
    children: [
      { name: 'Quartz Factory', path: '/sensors_collection/1', children: [] },
      { name: 'Thermo Cameras', path: '/sensors_collection/2', children: [] },
    ],
  },
  { name: 'Automation', path: '/device_list_automat', children: [] },
  { name: 'Projects', path: '/projects', children: [] },
  { name: 'Log Out', path: '/login', children: [] },
];;

//****** END MENU OBJECT ****************

const Navbar = (props) => {
  const dispatch = useDispatch();
  
  
  const fncLogOut = props.fncLogOut
  
  const [isOpen, setIsOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  //const [menuData, setMenuData] = useState([]);

  const location = useLocation();
  //const  menuData = useSelector((state) => state.dev.menuData);

  useEffect(() => {
    //setMenuData(menuDataR)
    //console.log('Navbar useEffect')
    //console.log(menuData2)
   }, [])

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };
/*   const ttt = useSelector((state) => state);
  console.log(ttt)(ttt) */

  const handleMenuClick = (item, path = []) => {
    //console.log(item, path)
    if (item.name === 'Log Out'){
      fncLogOut()
    } else {
      const newPath = [...path, item];
      setBreadcrumbs(newPath);
      if (!item.children || item.children.length === 0) {
        setActiveDropdown(null); // Collapse dropdown if clicking on a leaf node
      }
      
    }
    /* dispatch({ type: 'UDATE_STATE_ITEM', key: 'clickedMenu', payload: '3' }) */
  };

  const toggleDropdown = (item) => {
    setActiveDropdown((prev) => (prev === item ? null : item)); // Toggle active dropdown
  };

  const renderMenu = (items, parentPath = []) => {
    return items.map((item, y) => (
      <li
        key={'m_' + y}
        className={`nav-item ${item.children.length > 0 ? 'dropdown' : ''} ${
          activeDropdown === item ? 'show' : ''
        }`}
      >
        <Link
          className={`nav-link ml-2 ${item.children.length > 0 ? 'dropdown-toggle' : ''}`}
          to={item.path}
          onClick={(e) => {
            if (item.children && item.children.length > 0) {
              e.preventDefault(); // Prevent navigation for dropdown headers
              toggleDropdown(item);
            } else {
              handleMenuClick(item, parentPath);
            }
          }}
        >
          {item.name}
        </Link>
        {item.children.length > 0 && activeDropdown === item && (
          <ul className="dropdown-menu dropdown-menu-dark show" style={{background: "#4e565f"}}> {/* Added 'dropdown-menu-dark' */}
            {renderMenu(item.children, [...parentPath, item])}
          </ul>
        )}
      </li>
    ));
  };

  const renderBreadcrumbs = () => {
    const currentPath = breadcrumbs.length
      ? breadcrumbs
      : menuData.filter((item) => item.path === location.pathname);

    return (
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          {currentPath.map((item, index) => (
            <li
              key={index}
              className={`breadcrumb-item ${index === currentPath.length - 1 ? 'active' : ''}`}
              aria-current={index === currentPath.length - 1 ? 'page' : undefined}
            >
              <Link to={item.path}>{item.name}</Link>
{/*               {index === currentPath.length - 1 ? (
                item.name
              ) : (
                <Link to={item.path}>{item.name}</Link>
              )} */}
            </li>
          ))}
        </ol>
      </nav>
    );
  };

  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <Link className="navbar-brand" to="/">
          Navbar
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleNavbar}
          aria-controls="navbarSupportedContent"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto">{renderMenu(menuData)}</ul>
        </div>
      </nav>

      {/* <div className="container mt-3">{renderBreadcrumbs()}</div> */}
      <div className="container mt-3"><ProjNavСhain /></div>
    </div>
  );
};

export default Navbar;
